import { buyerStatusesStrings } from "./locale";
import PropTypes from "prop-types";

import {
  initLocalization,
  createBuyersStatusClasses,
} from "../../../utils/helpers";

export const BuyerStatusColored = ({ value, row }) => {
  initLocalization(buyerStatusesStrings);

  return (
    <span
      data-testid="buyer-status-color"
      className={createBuyersStatusClasses(row, value)}
    >
      {buyerStatusesStrings[value]}
    </span>
  );
};

BuyerStatusColored.propTypes = {
  row: PropTypes.object.isRequired,
  value: PropTypes.string.isRequired,
};
